import React, { type FC } from 'react'
import BreadcrumbAnswerStatus from './BreadcrumbAnswerStatus'

interface IProps {
  lastIndex: number
  userAnswers: IUserAnswer[]
  goToQuestion: (index: number) => void
}

const Breadcrumb: FC<IProps> = ({ lastIndex, userAnswers, goToQuestion }) => {
  const status = (userAnswer: IUserAnswer): boolean | undefined => {
    const answersRequired = userAnswer.question.answers.reduce((acc: number, answer: IAnswer) => {
      if (answer.isCorrect) acc += 1
      return acc
    }, 0)
    if (userAnswer.answers.length !== answersRequired) return undefined
    else if (userAnswer.answers.every((answer: IAnswer) => answer.isCorrect)) return true
    else return false
  }
  return (
    <div className='shrink-0 h-[5.5rem] bg-duskBlack text-pureWhite hidden lg:flex items-center gap-16 p-6 z-30'>
      <span>Start</span>
      <div className='w-full flex gap-2'>
        {userAnswers.map((userAnswer, index) => (
          <BreadcrumbAnswerStatus
            key={userAnswer.question.id}
            index={index}
            lastIndex={lastIndex}
            status={status(userAnswer)}
            goToQuestion={goToQuestion}
          />
        ))}
      </div>
      <span>Finish</span>
    </div>
  )
}

export default Breadcrumb
